<template>

    <section
        id="about"
        class="mission"
    >

        <div class="container">

            <span class="mission__subtitle">
                {{ 'home_mission' | staticContent }}
            </span>

            <h2 class="mission__title">
                {{ 'home_mission' | staticTitle }}
            </h2>

            <div class="mission__line"></div>
<!--
            <a
                href="#contact"
                class="mission__button"
            >
                {{ 'home_mission_button' | staticTitle }}
            </a>
-->
        </div>

    </section>

</template>

<script>
export default {
    name: 'HomeMission'
};
</script>

<style lang="scss" scoped>
.mission {
    padding: 90px 20px 100px;

    background: var(--background);

    text-align: center;

    &__subtitle {
        display: block;

        margin-bottom: 24px;

        color: var(--primary);

        font-size: 14px;
        font-weight: 700;

        letter-spacing: 2.5px;

        text-transform: uppercase;
    }

    &__title {
        max-width: 900px;

        margin: 0 auto;

        color: var(--text);

        font-family: 'Cormorant Garamond', serif;

        font-size: clamp(42px, 7vw, 72px);
        font-weight: 500;

        line-height: 1.05;

        text-transform: uppercase;
    }

    &__line {
        width: 46px;
        height: 2px;

        margin: 36px auto;

        background: var(--primary);
    }

    &__button {
        display: inline-flex;
        align-items: center;
        justify-content: center;

        min-width: 255px;
        min-height: 48px;

        padding: 0 24px;

        color: var(--primary);

        border: 1px solid var(--primary);

        font-size: 13px;
        font-weight: 700;

        letter-spacing: .4px;

        text-transform: uppercase;

        transition:
            background .3s ease,
            color .3s ease;

        &:hover {
            background: var(--primary);
            color: var(--white);
        }
    }
}

@media (min-width: 768px) {
    .mission {
        padding: 110px 20px 120px;

        &__subtitle {
            margin-bottom: 28px;
        }

        &__line {
            margin: 40px auto 34px;
        }
    }
}
</style>